import { AutocompleteAdapter } from 'components/form/AutocompleteAdapter';
import ReactFinalForm from 'components/form/ReactFinalForm';
import { TextFieldAdapter } from 'components/form/TextFieldAdapter';
import { required } from 'helpers/validators';
import { ILocation, IOption } from 'interfaces';
import { useEffect, useState } from 'react';
import { IdentityField } from 'components/form/IdentityField';
import { useTranslation } from 'react-i18next';
import { warehouseService } from 'services/api';

interface LocationFormParams {
  location: ILocation;
  onSubmit: any;
  disableEdit?: boolean;
}
function LocationForm(params: LocationFormParams) {
  const { t } = useTranslation();

  const [warehouses, setWarehouses] = useState<IOption[]>([]);

  useEffect(() => {
    warehouseService.getAllBaseInformation().then(setWarehouses);
  }, []);

  const { location, onSubmit, disableEdit } = params;
  return (
    <div>
      {location && (
        <ReactFinalForm
          onSubmit={disableEdit ? {} : onSubmit}
          edit={!!location.id}
          disableEdit={disableEdit}>
          <div className="flex flex-wrap">
            <div className="w-full mb-4 md:w-1/3 pr-4">
              <IdentityField
                name="code"
                initialValue={location.code}
                component={TextFieldAdapter}
                label={t('global.code')}
                type="text"
                validate={required}
                disabled={disableEdit}
              />
            </div>
            <div className="w-full mb-4 md:w-2/3">
              <IdentityField
                name="description"
                initialValue={location.description}
                component={TextFieldAdapter}
                label={t('global.description')}
                type="text"
                validate={required}
                disabled={disableEdit}
              />
            </div>
            <div className="w-full mb-4 my-4">
              {!location.warehouse && warehouses.length > 0 && (
                <IdentityField
                  name="warehouse"
                  component={AutocompleteAdapter}
                  options={warehouses}
                  initValue={warehouses.find((s) => s.code == location.warehouse)}
                  label={t('global.warehouse')}
                  type="text"
                  disabled={disableEdit}
                />
              )}
            </div>
          </div>
        </ReactFinalForm>
      )}
    </div>
  );
}

export default LocationForm;
